<ui-section>
  <ui-block width="5x">
    <!-- <ui-panel panelTitle="Dynamic Form"> -->
      <ui-form [config]="applicantInfoInputsConfig"
        [(formValues)]="formValues"
        (formValuesDelta)="delta = $event"
        [disabled]="isDisabled"
        >
      </ui-form>
    <!-- </ui-panel> -->
  </ui-block>

  <ui-block width="2x">
    <ui-panel panelTitle="formValues">
      <pre><code [highlightChange]="formValuesWithoutMetadata | json" [highlightChangeWordBoundaries]="true"></code></pre>
    </ui-panel>
  </ui-block>

  <ui-block width="1x" class="left flex flex-column">
    <ui-panel panelTitle="Controls">
      <ui-button (click)="isDisabled = !isDisabled"> Toggle Disabled</ui-button>

      <!--
        Example of binding to the formsValues property which will
        automatically propogate to/from the dynamic form in both directions.
        This <input> element knows nothing of the dynamic form.
      -->
      <div>First Name: <input [(ngModel)]="formValues['firstName']"/></div>
      <div>Last Name: {{lastName}} </div>
      <div>formValuesDelta: <b>{{delta | json}}</b></div>

    </ui-panel>
  </ui-block>
</ui-section>

